import { useEffect, useState } from 'react';

import { MemberContext } from 'src/contexts';
import { useGetCurrentMemberAccount } from 'src/hooks/accounts/get-current-member-account.hook';
import { IMemberContext, INITIAL_MEMBER } from 'src/contexts/member.context/member.context.model';

const MemberContextProvider: React.FC = props => {
  const [memberState, setMemberState] = useState<IMemberContext>(INITIAL_MEMBER);
  const { member, loading } = useGetCurrentMemberAccount();

  useEffect(() => {
    if (!loading && Object.keys(member).length) {
      setMemberState({
        currentMemberId: member._id,
        ganttId: member.ganttId,
        type: member.type,
        ganttsAccess: member.ganttsAccess,
      });
    }
  }, [member, loading]);

  return (
    <MemberContext.Provider value={memberState}>
      {loading ? null : props.children}
    </MemberContext.Provider>
  );
};

export default MemberContextProvider;
